import React from "react";
import { v4 as uuidv4 } from "uuid";
import { Tooltip } from "./Tooltip";
export const Descriptor = ({ message, icon = "info-sign", color = "#757575", placement = "top", }) => {
    return (React.createElement(Tooltip, { content: message, placement: placement, iconShown: false, tooltipId: uuidv4() },
        React.createElement("span", { className: `descriptor-icon glyphicon glyphicon-${icon}`, style: { color: color } })));
};
